import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdoptionMiddleware from './../modules/adoption/middleware'
import MenuComponent from './../components/Menu'

const mapStateToProps = ({ auth, adoption }) => ({
  user: auth.user,
  dueDate: adoption.adoptionDueDate,
  role: auth.userRole.role
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchAdoptionDueDate: () => AdoptionMiddleware.fetchAdoptionDueDate()
  }, dispatch)
}

class MenuContainer extends Component {
  componentDidMount () {
    this.props.fetchAdoptionDueDate()
  }

  render () {
    return (
      <MenuComponent dueDate={this.props.dueDate} role={this.props.role} />
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuContainer))



// WEBPACK FOOTER //
// ./src/containers/MenuContainer.js